import { render, staticRenderFns } from "./DetailedDashboard.vue?vue&type=template&id=3c4ccd66"
import script from "./DetailedDashboard.vue?vue&type=script&lang=ts"
export * from "./DetailedDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports